import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListField from 'components/molecules/Fields/ListField/ListField';
import utils from 'helpers/utils';

const StyledColorField = styled(ListField)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--color-field-columns': `${props.$columns}`,
      '--color-field-rows': `${props.$rows}`
    };

    return utils.styleProps(attr, vars);
  })`
  &.ColorField {
    min-width: ${props => props.theme.layout(100)};
    .List {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: repeat(${props => props.$css.$var('--color-field-columns', false)}, 1fr);
      grid-template-rows: repeat(${props => props.$css.$var('--color-field-rows', false)}, 1fr);
      gap: ${props => props.theme.layout('0.5sp')};
    }
  }
  ${ComponentStyles}
`;

StyledColorField.propTypes = {
  theme: PropTypes.object
};

export default StyledColorField;
